var render = function render(){var _vm=this,_c=_vm._self._c;return _c('examples-block',{attrs:{"gitUrl":"src/components/examples/Modal/modalView/UploaderModalComponent.vue","title":"Модальное окно с компонентом RUploader","description":"Загрузка файлов из под модального окна и обработка ошибки при загрузки компонентом"}},[_c('r-button',{attrs:{"title":"Отрыть модальное окно"},on:{"click":_vm.openModal}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }